<div class="fab dekstop-width-limiter {{ style }}" [title]="title | translate" [routerLink]="routerLink">
  <img *ngIf="!icon" src="./assets/images/FAB.svg">
  <div class="icon" *ngIf="icon"><mat-icon >{{icon}}</mat-icon></div>
  <span>{{title | translate}}</span>
</div>
